import { useParams } from "react-router-dom";
import { apiGet, useApiGet } from "../utils/api";
import { ProjectHeader } from "./project_header";
import { useQuery } from "react-query";
import { useState } from "react";
import { useProject } from "./helpers";

export const Search = () => {
  const { projectId } = useParams();
  const { project, refetch: refetchProject } = useProject();
  const [query, setQuery] = useState("");

  const { data, refetch, isSuccess, isFetching } = useQuery({
    queryKey: ["data", query],
    queryFn: () =>
      apiGet(`/projects/${projectId}/search`, { params: { query } }).then(
        (res) => res.data
      ),
    enabled: !!project && !!query,
    keepPreviousData: true,
  });

  if (!project) {
    return null;
  }

  return (
    <div>
      <ProjectHeader project={project} refetch={refetchProject} />

      <div className="input-group mb-3 w-300px">
        <div className="input-group">
          <span className="input-group-text">
            <i className="bi bi-search"></i>
          </span>
          <input
            type="text"
            className="form-control"
            placeholder="Search"
            aria-label="Search"
            aria-describedby="search-icon"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>
      </div>

      {isSuccess &&
        [
          { items: data?.pages, headers: ["Page", "Notes"], fields: ["name", "notes"] },
          {
            items: data?.notes,
            headers: ["Note", "Content"],
            fields: ["title", "content"],
          },
        ].map(
          ({ items, headers, fields }) =>
            items?.length > 0 && (
              <div className="table-responsive" key={headers[0]}>
                <table className="table">
                  <thead>
                    <tr>
                      <th className="w-200px">{headers[0]}</th>
                      <th>{headers[1]}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item) => (
                      <tr key={item.id}>
                        <td>{item[fields[0]]}</td>
                        <td>{item[fields[1]]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )
        )}
    </div>
  );
};
